import {h, Fragment} from "preact"
import { useAppState } from '@nosto/preact'
import { useState, useEffect } from 'preact/hooks'
import NoResults from '../serp/NoResults'
import Products from '../serp/Products'
import Toolbar from '../serp/Toolbar'
import Sidebar from '../serp/Sidebar'
import Pagination from '../serp/Pagination'
import Loader from '../serp/Loader'
import LoadMoreButton from '../serp/LoadMoreButton'

export default () => {
    const { response: { products }, loading } = useAppState();
    const [ sidebarActive, setSidebarActive ] = useState(false);
    const [ sortByActive, setSortByActive ] = useState(false);
    const foundProducts = products && products.total > 0

    useEffect(() => {
        sidebarActive || (sortByActive && window.innerWidth < 1000)
            ? document.querySelector('html').classList.add('lock-all')
            : document.querySelector('html').classList.remove('lock-all')
    }, [sidebarActive, sortByActive])

    const toggleSidebar = () => {
        setSidebarActive(prevSidebarActive => !sidebarActive);
    }

    const toggleSortBy = () => {
        setSortByActive(prevSortByActive => !prevSortByActive)
    }

    return (
        <div class="ns-serp" style={loading ? 'position: relative;' : ''}>
            {loading && !foundProducts ? (
                <Loader />
            ) : foundProducts ? (
                <>
                    <Sidebar 
                        toggleSidebar={toggleSidebar} 
                        sidebarActive={sidebarActive} />
                    <div class="ns-serp-body product-facet__main anchor">
                        <Toolbar 
                            toggleSidebar={toggleSidebar}
                            sortByActive={sortByActive}
                            toggleSortBy={toggleSortBy}
                        />
                        <div 
                            id="ns-products-view" 
                            hidden={false} 
                            role="region" 
                            aria-live="polite"
                        >
                            <Products />
                            {/* <Pagination /> */}
                            <LoadMoreButton/>
                        </div>
                    </div>
                </>
            ) : (
                <NoResults />
            )}
        </div>
    )
}
